export const createUserQueryKey = credentials => [
  `users/me`,
  { axiosOptions: { auth: credentials } }
]
